export default "__VITE_ASSET__DM01NnHZ__"